import {
  erpApiKeyQuery,
  useClearErpApiKeyMutation,
} from "@common/api/erp-api-keys"
import { ConfirmDialog } from "@common/components/shared/confirm-dialog"
import { getErrorMessage } from "@common/utils"
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"
import { requirePermission } from "@/lib/require-permission"

export const Route = createFileRoute(
  "/_layout/settings/_panel/integrations/erp/_list/api-key/revoke",
)({
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(
      queryClient,
      "erp_config:update",
      "/settings/workspace/general",
    ),
  loader: async ({ context: { queryClient } }) => {
    const { api_key } = await queryClient.ensureQueryData(erpApiKeyQuery())
    if (!api_key) {
      throw redirect({ to: "/settings/integrations/erp", replace: true })
    }
  },
  component: RevokeApiKeyDialog,
})

function RevokeApiKeyDialog(): React.ReactElement {
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const clearMutation = useClearErpApiKeyMutation()

  const close = () => navigate({ to: "/settings/integrations/erp" })

  const confirm = () =>
    clearMutation.mutate(
      {},
      {
        onSuccess: () => {
          showToast("Revoked", "Corridor API key revoked.", "success")
          close()
        },
        onError: (error) => showToast("Error", getErrorMessage(error), "error"),
      },
    )

  return (
    <ConfirmDialog
      title="Revoke the Corridor API key?"
      description="The Corridor sync stops importing straight away. This can't be undone."
      action="Revoke"
      pendingAction="Revoking…"
      pending={clearMutation.isPending}
      onConfirm={confirm}
      onCancel={close}
    />
  )
}
